import { getSunrise, getSunset } from 'sunrise-sunset-js'
import { defaultCenter } from '../constants'
import DateService, { FMT } from '../DateService'

export function buildDayNightItems({
  startDate,
  endDate,
  lat = defaultCenter.lat,
  lng = defaultCenter.lng
}) {
  const items = []
  let current = DateService.toDayjs(startDate, FMT.onlyDateDash).startOf('day')
  const end = DateService.toDayjs(endDate, FMT.onlyDateDash).endOf('day')

  let lastEnd = null

  while (current.isBefore(end) || current.isSame(end, 'day')) {
    const d = current.toDate()

    const sunrise = DateService.toDayjs(getSunrise(lat, lng, d))
    const sunset = DateService.toDayjs(getSunset(lat, lng, d))

    if (!lastEnd) {
      lastEnd = sunrise
      items.push({
        id: `night-first-${current.format('YYYYMMDD')}`,
        type: 'background',
        className: 'background-noche',
        start: sunrise.clone().subtract(1, 'day'),
        end: sunrise
      })
    } else if (lastEnd.isBefore(sunrise)) {
      items.push({
        id: `night-before-${current.format('YYYYMMDD')}`,
        type: 'background',
        className: 'background-noche',
        start: lastEnd,
        end: sunrise
      })
    }

    items.push({
      id: `day-${current.format('YYYYMMDD')}`,
      type: 'background',
      className: 'background-dia',
      start: sunrise,
      end: sunset
    })

    lastEnd = sunset

    current = current.add(1, 'day')
  }

  items.push({
    id: 'night-last',
    type: 'background',
    className: 'background-noche',
    start: lastEnd,
    end: lastEnd.add(1, 'day')
  })

  return items
}
